var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 3.00024H4.8C3.81 3.00024 3 3.81024 3 4.80024V19.2002C3 20.1902 3.81 21.0002 4.8 21.0002H19.2C20.19 21.0002 21 20.1902 21 19.2002V4.80024C21 3.81024 20.19 3.00024 19.2 3.00024ZM8.4 18.3002H5.7V10.2002H8.4V18.3002ZM7.05 8.67024C6.15 8.67024 5.43 7.95024 5.43 7.05024C5.43 6.15024 6.15 5.43024 7.05 5.43024C7.95 5.43024 8.67 6.15024 8.67 7.05024C8.67 7.95024 7.95 8.67024 7.05 8.67024ZM18.3 18.3002H15.6V13.5302C15.6 12.8103 14.97 12.1802 14.25 12.1802C13.53 12.1802 12.9 12.8103 12.9 13.5302V18.3002H10.2V10.2002H12.9V11.2802C13.35 10.5602 14.34 10.0202 15.15 10.0202C16.86 10.0202 18.3 11.4602 18.3 13.1702V18.3002Z",
    fill: "#F1DFDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.cbc2e4a44ce37966b2409f8b60308987.svg";
export { ForwardRef as ReactComponent };